// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.identification-photo video[data-v-52f0eb6f] {\n  max-width: 100%;\n  max-height: 30rem;\n  transition: transform 0.3s ease-in-out;\n}\n.media-box[data-v-52f0eb6f] {\n  position: relative;\n}\n", ""]);
// Exports
module.exports = exports;
